import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class YaBoLiveService {

    constructor(
        private httpService: HttpService,
        private AppConfig: AppConfig) { }

    /**登录亚博真人 */
    loginYaBoLive() {
        let url = AppConfig.GetProdUrl() + "/YBLive/LoginYaBoLive";
        return this.httpService.post(url, '');
    }
    /**转账到亚博真人 */
    transferToYaBoLive(amount: number) {
        let url = AppConfig.GetProdUrl() + "/YBLive/TransferToYaBoLive";
        return this.httpService.post(url, { Amount: amount, Type: 'ybl1' });
    }
    /**亚博真人转出 */
    transferFromYaBoLive(amount: number) {
        let url = AppConfig.GetProdUrl() + "/YBLive/TransferFromYaBoLive";
        return this.httpService.post(url, { Amount: amount, Type: 'ybl2' });
    }
    /**获取亚博真人余额 */
    getYaBoLiveBalance() {
        let url = AppConfig.GetProdUrl() + "/YBLive/GetBalance";
        return this.httpService.post(url, '');
    }
    /**获取转账记录 */
    getTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/YBLive/GetTransferList";
        return this.httpService.post(url, params);
    }
    /**获取投注记录 */
    getBettingList(params) {
        let url = AppConfig.GetProdUrl() + "/YBLive/GetBettingList";
        return this.httpService.post(url, params);
    }
    /**获取游戏列表下拉菜单 */
    getGameListDrop(params) {
        let url = AppConfig.GetProdUrl() + "/YBLive/GetGameListDrop";
        return this.httpService.post(url,  params);
    }

}


// WEBPACK FOOTER //
// ./src/services/yabolive.service.ts